import { Box, CircularProgress } from "@mui/material";

type Props = {
  color?: "primary" | "grey";
  size?: number;
};

export const CenteredCircularProgress = ({
  color = "primary",
  size,
}: Props) => {
  const props = color === "grey" ? { sx: { color: "grey.300" } } : {};

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
    >
      <CircularProgress {...props} size={size} />
    </Box>
  );
};
